import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';

import styles from './index.less';
import aos from '@src/utils/aos';

import Marquee from 'react-fast-marquee';

import SupplierStore from './store';
// import SilentVideo from '@src/components/silent-video';
const SupplierCompon = ({ store }) => {
  store.use();
  aos.reInit();
  console.log(store.logoList, 'store.logoListstore.logoList');

  return (
    <div
      className={styles.logoListCont}
      style={{ overflowX: 'hidden', overflowY: 'hidden' }}
      {...aos.FADE_UP()}
      data-aos-duration="500"
      data-aos-easing="ease-out"
      data-aos-offset="30"
      data-aos-once="true"
    >
      <Marquee gradient={true} gradientColor="#F4F7FC" className="bopxx" gradientWidth={150} loop={0}>
        {store.logoList.map((item, index) => <img className={styles.logo} src={item.logo} key={index} alt="" />)}
      </Marquee>
    </div>
  );
};

export default wrapStore(SupplierCompon, SupplierStore);
